export default __webpack_public_path__ + "static/media/logo-equity.d6cb643d.png";